module.exports = __webpack_public_path__ + "static/media/Colette Curve Queen Headboard - 155 cm_Burnt Orange.230d06f6.png";